export const AUSPICIOUS_ACTIVITIES = [
    'planting',
    'haircut',
    'starting',
    'contracts',
    'cleaning',
    'travel',
];
//# sourceMappingURL=types.js.map